// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page Container */
.page-container {
  font-family: "Inter", sans-serif;
  color: #333;
}

/* Hero Section */
.hero {
  background: linear-gradient(135deg, #1a73e8, #34a853);
  color: #fff;
  text-align: center;
  padding: 120px 20px 80px 20px;
}

.hero-title {
  font-size: 3rem;
  margin-bottom: 20px;
}

.hero-sub {
  font-size: 1.2rem;
  margin-bottom: 30px;
}

.hero-buttons button {
  margin: 0 8px;
}

.btn-primary {
  background-color: #fff;
  color: #1a73e8;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #e0e0e0;
}

.btn-outline {
  border: 2px solid #fff;
  color: #fff;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  background-color: #fff;
  color: #1a73e8;
}

/* Product Cards */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  padding: 40px 20px;
}

.card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}

.card-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.card-text {
  font-size: 0.95rem;
  margin-bottom: 12px;
}

.card-price {
  font-weight: 500;
  color: #1a73e8;
  margin-bottom: 12px;
}

.btn-register {
  background-color: #34a853;
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-register:hover {
  background-color: #2a8f42;
}

/* Mini Cards */
.grid-small {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  padding: 20px;
}

.mini-card {
  background: #f5f5f5;
  padding: 16px;
  border-radius: 10px;
  text-align: center;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.mini-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.1);
}

.section-title {
  margin-top: 60px;
  font-size: 1.6rem;
  text-align: center;
  margin-bottom: 20px;
  color: #1a73e8;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  width: 320px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.2);
}

.modal input {
  width: 100%;
  padding: 8px 12px;
  margin: 6px 0;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.modal-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
}

.modal button[type="submit"] {
  background-color: #34a853;
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

.modal button[type="submit"]:hover {
  background-color: #2a8f42;
}

.modal button[type="button"] {
  background-color: #ccc;
  color: #333;
  padding: 8px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/StartForm.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/* Page Container */\n.page-container {\n  font-family: \"Inter\", sans-serif;\n  color: #333;\n}\n\n/* Hero Section */\n.hero {\n  background: linear-gradient(135deg, #1a73e8, #34a853);\n  color: #fff;\n  text-align: center;\n  padding: 120px 20px 80px 20px;\n}\n\n.hero-title {\n  font-size: 3rem;\n  margin-bottom: 20px;\n}\n\n.hero-sub {\n  font-size: 1.2rem;\n  margin-bottom: 30px;\n}\n\n.hero-buttons button {\n  margin: 0 8px;\n}\n\n.btn-primary {\n  background-color: #fff;\n  color: #1a73e8;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.btn-primary:hover {\n  background-color: #e0e0e0;\n}\n\n.btn-outline {\n  border: 2px solid #fff;\n  color: #fff;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.btn-outline:hover {\n  background-color: #fff;\n  color: #1a73e8;\n}\n\n/* Product Cards */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 20px;\n  padding: 40px 20px;\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 6px 18px rgba(0,0,0,0.1);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 25px rgba(0,0,0,0.15);\n}\n\n.card-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.card-text {\n  font-size: 0.95rem;\n  margin-bottom: 12px;\n}\n\n.card-price {\n  font-weight: 500;\n  color: #1a73e8;\n  margin-bottom: 12px;\n}\n\n.btn-register {\n  background-color: #34a853;\n  color: #fff;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.btn-register:hover {\n  background-color: #2a8f42;\n}\n\n/* Mini Cards */\n.grid-small {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  padding: 20px;\n}\n\n.mini-card {\n  background: #f5f5f5;\n  padding: 16px;\n  border-radius: 10px;\n  text-align: center;\n  font-weight: 500;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.mini-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 12px rgba(0,0,0,0.1);\n}\n\n.section-title {\n  margin-top: 60px;\n  font-size: 1.6rem;\n  text-align: center;\n  margin-bottom: 20px;\n  color: #1a73e8;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.modal {\n  background: #fff;\n  padding: 24px;\n  border-radius: 12px;\n  width: 320px;\n  box-shadow: 0 6px 18px rgba(0,0,0,0.2);\n}\n\n.modal input {\n  width: 100%;\n  padding: 8px 12px;\n  margin: 6px 0;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 12px;\n}\n\n.modal button[type=\"submit\"] {\n  background-color: #34a853;\n  color: #fff;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n}\n\n.modal button[type=\"submit\"]:hover {\n  background-color: #2a8f42;\n}\n\n.modal button[type=\"button\"] {\n  background-color: #ccc;\n  color: #333;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
